// Partner Brands query-key factory (stale-after-save convention: queryKey
// arrays live only in *Keys files; every mutation invalidates by prefix).

export const partnerBrandKeys = {
  all: ["partner-brands"] as const,
  list: () => [...partnerBrandKeys.all, "list"] as const,
  detail: (id: string) => [...partnerBrandKeys.all, "detail", id] as const,
  /** Nested under `all` so any brand mutation re-reads it: whether a site can
   *  be deleted depends on what still references it. */
  deleteEligibility: (id: string) =>
    [...partnerBrandKeys.all, "delete-eligibility", id] as const,
};
